import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateDevice } from 'app/dtos/device/updateDevice';
import { AuthService } from 'app/services/auth.service';
import { BrandService } from 'app/services/models/brand.service';
import { CompanyService } from 'app/services/models/company.service';
import { DeviceService } from 'app/services/models/device.service';
import { KindService } from 'app/services/models/kind.service';
import { PersonService } from 'app/services/models/person.service';
import { ReferenceService } from 'app/services/models/reference.service';
import { ToastrService } from 'ngx-toastr';
import { ReferenceTransactionsComponent } from '../reference-transactions/reference-transactions.component';

@Component({
  selector: 'app-update-device-dialog',
  templateUrl: './update-device-dialog.component.html',
  styleUrls: ['./update-device-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateDeviceDialogComponent implements OnInit {
  @Input() data: { id: number, isReferenceDevice: boolean };
  deviceForm: FormGroup;

  device: any = {};
  brands: any[];
  kinds: any[];
  companies: any[];
  companyPersons: any[];
  references: any[];

  constructor(
    private brandService: BrandService,
    private fb: FormBuilder,
    private kindSerivce: KindService,
    private companyService: CompanyService,
    public activeModal: NgbActiveModal,
    private deviceSerivce: DeviceService,
    private personSerivce: PersonService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    public authService: AuthService,
    private referenceService: ReferenceService) {
    this.deviceForm = this.fb.group({
      companyId: [null, Validators.required],
      companyPersonId: [null],
      deviceName: [null, Validators.required],
      code: [null],
      brandModelId: [null, Validators.required],
      brandId: [null, Validators.required],
      kindId: [null, Validators.required],
      seriNo: [null],
      inventoryNumber: [null],
      description: [null],
      resolution: [''],
      referenceId: [null],
      period: [null],
      place: [''],
      isDeviceStatus: [false]  // <-- Add this line
    });
  }

  async ngOnInit() {
    await this.getAllBrand();
    await this.getAllKinds();
    await this.getAllCompaines();

    this.deviceForm.get('companyId').valueChanges.subscribe((companyId) => {
      if (companyId) {
        this.getAllCompanyPersons(companyId);
      }
    });

    if (this.data.id) {
      await this.getByIdDevice(this.data.id)
    }
    await this.getAllReferences(this.device.kindId);

  }

  filteredModels: any[] = [];

  onBrandChange(brandId: number) {
    this.filteredModels = [];
    console.log(brandId);
    const brand = this.brands.find(p => p.id === brandId);
    this.filteredModels = brand.brandModels || [];
    const selectedModelId = this.deviceForm.get('brandModelId')?.value;
    const isValidModel = this.filteredModels.some(m => m.id === selectedModelId);

    if (!isValidModel) {
      this.deviceForm.get('brandModelId')?.setValue(null);
    }
  }

  async getAllReferences(kindId) {
    const data = await this.referenceService.getAllReference(0, 1000,kindId);
    console.log(data);
    this.references = data.references;
  }

  async getByIdDevice(id) {
    const data = await this.deviceSerivce.getByIdDevice(id);
    console.log(data);
    this.device = data;
    this.deviceForm.patchValue({
      companyId: this.device.companyId,
      companyPersonId: this.device.companyPersonId,
      deviceName: this.device.deviceName,
      brandModelId: this.device.brandModelId,
      brandId: this.device.brandId,
      kindId: this.device.kindId,
      seriNo: this.device.seriNo,
      description: this.device.description,
      isDeviceStatus: this.device.isDeviceStatus,
      resolution: this.device.resolution,
      referenceId: this.device.referenceId,
      period: this.device.period,
      calibrationStatus: this.device.calibrationStatus,
      place: this.device.place,
      inventoryNumber: this.device.inventoryNumber
    });

    this.deviceForm.get('companyId').valueChanges.subscribe((companyId) => {
      if (companyId) {
        this.getAllCompanyPersons(companyId);
      }
    });
    if (this.device.brandId) {
      this.onBrandChange(this.device.brandId);
    }
  }

  searchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name?.toLowerCase().includes(term) || item.brandName?.toLowerCase().includes(term);
  }

  async getAllKinds() {
    const data = await this.kindSerivce.getAllKinds('', 0, 100, 13);
    console.log(data);
    this.kinds = data.types;
  }

  async getAllCompaines() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async getAllCompanyPersons(companyId) {
    const data = await this.personSerivce.getAllCompaniesPersons(0, 1000, companyId);
    this.companyPersons = data.persons;
    console.log(data);
  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data;
    console.log(this.brands);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    console.log(this.deviceForm.value);
    if (this.deviceForm.valid) {
      const formValue = this.deviceForm.value;
      const updateDevice: UpdateDevice = {
        id: this.device.id, // device id
        deviceName: formValue.deviceName,
        code: formValue.code,
        brandModelId: formValue.brandModelId,
        seriNo: formValue.seriNo,
        kindId: formValue.kindId,
        companyId: formValue.companyId,
        companyPersonId: formValue.companyPersonId,
        isDeviceStatus: formValue.isDeviceStatus === 'true' || formValue.isDeviceStatus === true,
        description: formValue.description,
        updateDeviceAdditionalInformation: {
          id: this.device.deviceIformationId, // Or assign a new ID if needed
          resolution: formValue.resolution,
          referenceId: formValue.referenceId,
          period: formValue.period,
          deviceId: this.device.id, // deviceId to match the form
          inventoryNumber: formValue.inventoryNumber,
          place: formValue.place
        }
      };

      console.log(updateDevice);
      const data = await this.deviceSerivce.updateDevice(
        updateDevice);
      if (data.status == true) {
        this.closeModal();
        this.deviceSerivce.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    }
  }

  showCreateReferenceDialog() {
    const modal = this.modalService.open(ReferenceTransactionsComponent, {
      size: 'sm',
      backdrop: 'static',
    });
    modal.result.then(async (result) => {
      console.log(result);
      if (result === true) {
        await this.getAllReferences(this.device.kindId);
      }
    }).catch(() => { })
  }
}
